import React from 'react';

import { PrintCustomsRequestLog as PrintCustomsRequestLogImpl } from '@components/utilities/CustomsRequest/PrintCustomsRequestLog';

export const PrintCustomsRequestLog = () => {
  return <PrintCustomsRequestLogImpl type="external" />;
};
